import { createContext, useContext } from 'react';

const ACEditContext = createContext({
  editMode: '',
  backToDef: '',
  editFolderDetails: {},
  createDefMode: '',
  seteditMode: () => {},
  setbackToDef: () => {},
  seteditFolderDetails: () => {},
  setcreateDefMode: () => {},
});

export const useACEditContext = () => useContext(ACEditContext);

export default ACEditContext;
